<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="visible" class="modal-overlay" @click="handleCancel">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h3 class="modal-title">{{ title }}</h3>
            <button class="modal-close" @click="handleCancel">×</button>
          </div>
          
          <div class="modal-body">
            <p class="modal-message">{{ message }}</p>
          </div>
          
          <div class="modal-footer">
            <button 
              class="btn btn-cancel" 
              @click="handleCancel"
              :disabled="loading"
            >
              {{ cancelText }}
            </button>
            <button 
              class="btn btn-confirm" 
              @click="handleConfirm"
              :disabled="loading"
            >
              {{ loading ? '处理中...' : confirmText }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '确认操作'
    },
    message: {
      type: String,
      default: '确定要执行此操作吗？'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'cancel', 'update:visible'],
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
    handleCancel() {
      if (!this.loading) {
        this.$emit('cancel')
        this.$emit('update:visible', false)
      }
    }
  }
}
</script>

<style scoped>
/* 简洁现代风格 - 类似图片中的样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: #ffffff;
  border-radius: 6px;
  width: 90%;
  max-width: 540px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  position: relative;
}

.modal-header {
  padding: 20px 24px 16px;
  background: white;
  position: relative;
}

.modal-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  line-height: 1.5;
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 24px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  font-weight: 300;
  line-height: 1;
}

.modal-close:hover {
  color: #374151;
}

.modal-body {
  padding: 0 24px 24px;
  color: #374151;
  font-size: 18px;
  line-height: 1.6;
}

.modal-message {
  margin: 0;
  color: #374151;
  font-size: 18px;
  line-height: 1.6;
}

.modal-footer {
  padding: 16px 24px 20px;
  text-align: right;
  background: white;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.btn {
  padding: 8px 20px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  font-weight: 400;
  line-height: 1.5;
  min-width: 88px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cancel {
  background: white;
  color: #374151;
  border-color: #e5e7eb;
}

.btn-cancel:hover:not(:disabled) {
  color: #374151;
  border-color: #d1d5db;
  background: #f9fafb;
}

.btn-confirm {
  background: #3d7af6;
  color: white;
  border-color: #3d7af6;
}

.btn-confirm:hover:not(:disabled) {
  background: #4285f4;
  border-color: #4285f4;
}

/* 简洁动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active .modal-content {
  animation: modal-zoom-in 0.2s ease;
}

.fade-leave-active .modal-content {
  animation: modal-zoom-in 0.2s ease reverse;
}

@keyframes modal-zoom-in {
  0% {
    transform: scale(0.95);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>